import { default as filenames } from '../assets/i18n/_i18nmappings.json';

export const environmentCommon = {
	appName: 'Aston',
	appVersion: '1.0.0',
	translations: {
		/* if the website has translation */
		enabled: true,
		filenames: filenames as string[]
	},
	loginConfig: {
		passwordMinLength: 8
	}
};
